import React from "react";
import { FaInstagram, FaWhatsapp, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-6">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
        <div>
          <h3 className="text-orange-500 font-bold mb-2">Company info</h3>
          <p className="text-sm">
            Haptic Realities company provides online/offline training and
            services in 3D animation, visual effects, motion graphics, and game
            development. We offer classes, workshops, and other educational
            resources.
          </p>
        </div>
        <div>
          <h3 className="text-yellow-400 font-bold mb-2">Address</h3>
          <p className="text-sm">
            HAPTIC REALITIES
            <br />
            4th Floor, Alluri Trade Center,
            <br />
            Usha Mullapudi Cardio Hospital Road,
            <br />
            Bhagya Nagar colony, Kukatpally,
            <br />
            Hyderabad-500072
            <br />
            Telangana, India.
          </p>
        </div>

        <div>
          <h3 className="text-yellow-400 font-bold mb-2">Contact Us</h3>
          <p className="flex items-center justify-center text-sm mb-2">
            <FaPhoneAlt className="mr-2 text-green-500" />
            +91 90141 62312
          </p>
          <p className="flex items-center justify-center text-sm">
            <FaEnvelope className="mr-2 text-blue-500" />
            Info@hapticrealities.com
          </p>
        </div>

        <div>
          <h3 className="text-yellow-400 font-bold mb-2">Follow Us</h3>
          <div className="flex justify-center gap-4 mt-2">
            <a
              href="https://www.instagram.com/hapticrealities/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram className="w-5 h-5 cursor-pointer hover:text-pink-500" />
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=919014162312&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp className="w-5 h-5 cursor-pointer hover:text-green-400" />
            </a>
            <a
              href="https://twitter.com/hapticrealities" // Replace with actual Twitter link
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaXTwitter className="w-5 h-5 cursor-pointer hover:text-blue-400" />
            </a>
            <a
              href="https://www.facebook.com/hapticrealities" // Replace with actual Facebook link
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook className="w-5 h-5 cursor-pointer hover:text-blue-600" />
            </a>
          </div>
        </div>
      </div>

      <section id="footer" className="mt-10 text-center text-sm">
        <p>
          &copy; {new Date().getFullYear()} Haptic Realities. All rights
          reserved.
        </p>
      </section>
    </footer>
  );
};

export default Footer;
